export default __webpack_public_path__ + "static/media/four.feda3cde.jpeg";